import { Component, inject } from '@angular/core';
import { IconDefinition } from "@fortawesome/fontawesome-svg-core";
import { Toast } from "../../models/common.model";
import { faCheckCircle, faExclamationCircle, faExclamationTriangle, faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import { ModalService } from "../modal/modal.service";
import { CommonModule } from "@angular/common";
import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";

@Component({
  selector: 'app-toast',
  imports: [CommonModule,FontAwesomeModule],
  templateUrl: './toast.component.html',
  styleUrl: './toast.component.css'
})
export class ToastComponent {
    private modalService = inject(ModalService);
    toast!: Toast ;

    ngOnInit() {
        setTimeout(() => {
            this.removeToast();
        },this.toast.timeout ?? 1700);
    }
    private typeToIconMap: { [key in Toast['type']]: IconDefinition } = {
        success: faCheckCircle,
        error: faExclamationCircle,
        warning: faExclamationTriangle,
        info: faInfoCircle
    };


    removeToast() {
        const toastElement = document.querySelector('.animate-fade-in');
    if (toastElement) {
        toastElement.classList.remove('animate-fade-in');
        toastElement.classList.add('animate-fade-out');

        setTimeout(() => {
            this.modalService.close();
            if(this.toast.callback) {
            this.toast.callback();
            }
        }, 300); // Delay to match animation duration
        } else {
        this.modalService.close();
            if(this.toast.callback) {
                this.toast.callback();
            }
        }
    }


    /**
     * Get the appropriate icon for the toast type.
     */
    getIcon(type: Toast['type']): IconDefinition {
        return this.typeToIconMap[type];
    }

    getBackgroundColorStart(type: string): string {
        switch (type) {
            case 'success':
            return '#E8F5E9'; // Light green
            case 'error':
            return '#FFEBEE'; // Light red
            case 'warning':
            return '#FFFDE7'; // Light yellow
            case 'info':
            return '#E3F2FD'; // Light blue
            default:
            return '#F5F5F5'; // Light gray (default)
        }
    }

    getBackgroundColorEnd(type: string): string {
        switch (type) {
            case 'success':
            return '#A5D6A7'; // Darker green
            case 'error':
            return '#E57373'; // Darker red
            case 'warning':
            return '#FFF59D'; // Darker yellow
            case 'info':
            return '#90CAF9'; // Darker blue
            default:
            return '#E0E0E0'; // Darker gray
        }
    }


    getTranslationKey(type: string): string {
        switch (type) {
            case 'success':
            return 'TOAST_TYPE_SUCCESS';
            case 'error':
            return 'TOAST_TYPE_ERROR';
            case 'warning':
            return 'TOAST_TYPE_WARNING';
            case 'info':
            return 'TOAST_TYPE_INFO';
            default:
            return 'TOAST_TYPE_UNKNOWN';
        }
    }

}
